import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import WeeklyLogModalParent from './WeeklyLogModalParent';
import { FlexBox } from '../../../components/tableItems';
import { MainButton } from '../../../components/buttons';
import { UserContextType } from '../../../models/User';
import Context from '../../../context/UserContext';
import { IS_USER_ADMIN } from '../../../constants/user';

interface WarningWeeklyLogModalProps {
  open: boolean;
  closeModal: () => void;
}

const WarningWeeklyLogModal: React.FC<WarningWeeklyLogModalProps> = ({
  open,
  closeModal,
}) => {
  const { UserContext } = useContext(Context) as UserContextType;

  return (
    <WeeklyLogModalParent
      title="Alert"
      closeModal={() => {
        if (IS_USER_ADMIN.includes(UserContext.profile.role))
          return closeModal();

        return () => {};
      }}
      open={open}
      hideExit={!IS_USER_ADMIN.includes(UserContext.profile.role)}
    >
      <Box marginTop={2}>
        <Typography fontSize={14} align="center">
          In order to use BackLink you must complete your Weekly Linkbuilding
          Log from {UserContext.logs_completion.start_date} to{' '}
          {UserContext.logs_completion.end_date}
        </Typography>
      </Box>

      <Box marginTop={3.5}>
        <FlexBox marginTop={3} justifyContent="center">
          {IS_USER_ADMIN.includes(UserContext.profile.role) && (
            <MainButton
              onClick={() => closeModal()}
              variant="contained"
              sx={{
                backgroundColor: '#F0F0F0',
                color: 'black',
                marginRight: 1,
                '&:hover': {
                  backgroundColor: '#F2F2F2',
                },
              }}
            >
              Cancel
            </MainButton>
          )}
          <MainButton
            variant="contained"
            onClick={() => {
              closeModal();
            }}
            disabled={false}
            loading={false}
            sx={{ marginLeft: 1 }}
          >
            Confirm
          </MainButton>
        </FlexBox>
      </Box>
    </WeeklyLogModalParent>
  );
};

export default WarningWeeklyLogModal;
